<template>
  <div id="login_page" style="display: none">
    <div class="formContainer flex-mid fc-FFFFFF">
      <div class="divContainer2">
        <div style="padding: 52px 160px 0 160px">
          <div class="center">
            <img
              src="../assets/images/wv-monthly-insights/Icon.png"
              class="imgLogo p-11"
            />
          </div>
          <div class="fs-24 fw-800 mt-32">
            {{ $t("sso.your") }} <span class="fc-FBC02D">SSO</span>
          </div>
          <div v-if="authData.email" class="mt-24 fs-16">
            {{ $t("sso.this_account") }} ({{ authData.email }})
            {{ $t("sso.has_been_set") }}
          </div>
          <div v-if="false" class="mt-12">
            <div
              class="center fc-FFFFFF"
              style="
                height: 31px;
                width: 191px;
                background-color: white;
                border-radius: 4px;
                color: gray;
                padding-top: 11px;
              "
            >
              <span class="fw-900">APIs</span> {{ $t("sso.google_sign_In") }}
            </div>
          </div>

          <!-- Check that the SDK client is not currently loading before accessing is methods -->
          <div v-if="!loading">
            <div v-if="true || !user.email" class="mt-12" @click="login">
              <div
                class="center fc-FFFFFF"
                style="
                  height: 31px;
                  width: 191px;
                  background-color: white;
                  border-radius: 4px;
                  color: gray;
                  padding-top: 11px;
                "
              >
                <span class="fw-900">{{ $t("sso.sign_In") }}</span>
              </div>
            </div>
            <div v-if="user.email" class="mt-12" @click="logout">
              <div
                class="center fc-FFFFFF"
                style="
                  height: 31px;
                  width: 191px;
                  background-color: white;
                  border-radius: 4px;
                  color: gray;
                  padding-top: 11px;
                "
              >
                <span class="fw-900">{{ $t("sso.sign_Out") }}</span>
              </div>
            </div>
          </div>

          <div class="mt-40 pt-2">
            <el-button class="btnSignIn" type="primary" @click="goBack">{{
              $t("register.go_back")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import router from '@/router';
import format from 'date-fns/format';
import axios from 'axios';
import { buildSessionUser, getByUser, getCompany, setSessionUserData } from '../store/core/cacheService'

const DEFAULT_SSO_EXCHANGE_URL = 'https://us-central1-people2-admin.cloudfunctions.net/happilyTeamsSsoExchange'

export default {
  async created() {
    await this.login();
  },
  computed: {
    user() {
      return firebase.auth().currentUser || {};
    },
    authData() {
      return this.$store.getters["sso/authData"] || {};
    },
    autoLogin() {
      return this.$store.getters["sso/autoLogin"] || {};
    },
  },
  data() {
    return {
      loading: false,
      // user: {
      //   email: "user@example.com",
      // },
    };
  },
  methods: {
    // Log the user in
    async login() {
      const loginSsoId = this.$route.params.id;
      if (!loginSsoId) {
        router.replace('login');
        return;
      }

      try {
        const ssoExchangeUrl = process.env.VUE_APP_SSO_EXCHANGE_URL || DEFAULT_SSO_EXCHANGE_URL;
        const exchange = await axios.post(
          ssoExchangeUrl,
          { attemptId: loginSsoId },
          { headers: { 'Content-Type': 'application/json' } }
        );
        const exchangeData = exchange.data || {};

        if (!exchangeData.customToken || !exchangeData.session || !exchangeData.session.email) {
          router.replace('login');
          return;
        }

        await firebase.auth().signInWithCustomToken(exchangeData.customToken);

        const user = await getByUser(exchangeData.session.email);
        if(!user){
          firebase.auth().signOut();
          router.replace('login');
          return;
        }

        const company = await getCompany(user.company)
        const user2 = buildSessionUser(user, company, false)

        this.$store.commit("authen/setUserLogin", user2, {root: true});

        localStorage.setItem('userVersion',await (await firebase.database().ref(`version/my_version`).once("value")).val());
        if (!setSessionUserData(user2)) {
          firebase.auth().signOut();
          router.replace('login');
          return;
        }

        /*save logs*/
        await this.$store.dispatch('authen/addLogs', {
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          status: 'login',
          user: user.email
        }, {root:true});

        setTimeout(() => {
          if (user.user_type == 'admin') {
            router.replace('/members')
          } else if(user.user_type == 'developer'){
            router.replace('/integrations')
          } else{
            router.replace('/')
          }
          this.$store.commit('authen/loadingStatus', false, { root: true });
        }, 500);
      } catch (error) {
        console.error('SSO login exchange failed:', error);
        firebase.auth().signOut();
        router.replace('login');
      }
    },
    // Log the user out
    logout() {
      // console.log("logout()");
      const authData = this.$store.getters["sso/authData"];
      // this.$store.dispatch("sso/logout", authData);

      this.$store.dispatch("auth/logout", authData, {root: true})

      // this.$sso.logout({
      //   returnTo: window.location.origin + "/sso-login",
      // });
    },
    submitForm() {
      console.log("submitForm"); // TODO: ....
    },
    goBack() {
      this.$router.push('login');
    },
  },
};
</script>

<style lang="scss" scoped>
.formContainer {
  min-height: 100vh;
  height: calc(100vh);
  background-color: #6c30cc;
}
.divContainer2 {
  width: 640px;
  min-height: 600px;
  background: rgba($color: #111111, $alpha: 0.12);
  border-radius: 4px;
  transition: 0.3s;
  margin: auto;
}
.imgLogo {
  width: 64px;
  height: 64px;
}
.btnSignIn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-weight: 700;
  border-width: 0px;
  background-color: rgba($color: #ffffff, $alpha: 0.2);
  transition: 0.3s;
  &:hover {
    background-color: rgba($color: #ffffff, $alpha: 0.22);
  }
}
</style>
